import { useSelector } from "react-redux";

import { selectControlFlowEnabledDynamic } from "store/slices/apisShared/selectors/controlFlowEnabledDynamic";

export const useIsControlFlowEnabled = (): boolean => {
  return useSelector(selectControlFlowEnabledDynamic);
};
